import { render, staticRenderFns } from "./CardLetter.vue?vue&type=template&id=0426d135"
import script from "./CardLetter.vue?vue&type=script&lang=js"
export * from "./CardLetter.vue?vue&type=script&lang=js"
import style0 from "./CardLetter.vue?vue&type=style&index=0&id=0426d135&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports